import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';

interface FrontendVersion {
  version: string;
  buildNumber: number;
}

interface BackendVersion {
  version: string;
  fileVersion: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private readonly http = inject(HttpClient);

  readonly portalVersion = signal<string>('');
  readonly frontendVersion = signal<string>('');
  readonly backendVersion = signal<string>('');

  constructor() {
    this.fetchFrontendVersion();
    this.fetchBackendVersion();
  }

  private fetchFrontendVersion(): void {
    this.http
      .get<FrontendVersion>('/assets/version.json')
      .pipe(catchError(() => of(null)))
      .subscribe((res) => {
        if (res) {
          this.portalVersion.set(res.version);
          this.frontendVersion.set(res.buildNumber ? `${res.version}+${res.buildNumber}` : res.version);
        }
      });
  }

  private fetchBackendVersion(): void {
    this.http
      .get<BackendVersion>(`${environment.coreApiUrl}/version`)
      .pipe(catchError(() => of(null)))
      .subscribe((res) => {
        if (res?.version) {
          this.backendVersion.set(res.version);
        }
      });
  }
}
